/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         30/04/25 - 14:01:33
 * Module name:  breadcrumb-storage-key.const
 * File name:    breadcrumb-storage-key.const.ts
 * IDE:          WebStorm
 */

export const BREADCRUMB_STORAGE_KEY = 'mkad_breadcrumb';
export const BREADCRUMB_HOME_STORAGE_KEY = 'mkad_home_breadcrumb';
